import { useRecoilValue } from "recoil";
import { gradeListState } from "../hooks/useGradeList";
import kkotalkEventSetData from "../datafiles/kkotalkevent_set.json";
import alimtalkStatus from "../AdminApi/alimtalkAPIstatus_set.json";
import { utils, writeFile, WorkBook, read, write } from "xlsx";
import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { ChangeEvent } from "react";
import kakaoStatus from "../AdminApi/kakao_biz_status_set.json";
import smsStatus from "../AdminApi/sms_status_set.json";
import ssetUserEvent from "../datafiles/ssetuserevent_set.json";
import autoPushEvent from "../datafiles/autopushevent_set.json";
import { GetSubscriptionSetData } from "../ApiTS/ServiceDatasTS";
import { OptionType } from "../components/Filters/DropDown";
import { CPState } from "../Api/Types";
import { getDiffDay } from "../ApiTS/LinkidCalc";
import alertevent_set from "../data_json/alertevent_set.json";
import {
  GetAllNoHideSubsnameListv3,
  GetAllSubsnameListV3,
  getShareDefData,
  GetSubscriptionSetData_V3,
  getUserEventData,
} from "../ApiTS/ServiceDatasTS_V3";
import { getSubsNameBySubsId3 } from "./3.0_utils";

import subscription_set_V3 from "../data_json/subscription_set.json";

interface IWorkBookCallBack {
  (workbook?: WorkBook): void;
}

export const getManagerGrade = (grade: string | null) => {
  switch (grade) {
    case "1":
      return "최고 관리자";

    case "2":
      return "일반 관리자";

    case "3":
      return "외부 관리자";

    default:
      return "";
  }
};

// 관리자 스트링
export const GetGradeString = (grade: string | null) => {
  const gradeList = useRecoilValue(gradeListState);

  const gradeString = gradeList?.find(
    (val) =>
      val?.value === grade ||
      String(val?.value) === grade ||
      String(val?.value) === grade,
  )?.label;

  return gradeString;
};

// mglog에 따른 party pay data
export const getPartyPayDataByMgLog = (
  type: string,
  details: string,
  reason: string,
  isOwner: boolean,
) => {
  let startIndex = details.indexOf("(") + 1;
  let endIndex = details.indexOf(")");
  const targetUid = details.substring(startIndex, endIndex);

  if (type === "spend") {
    switch (details) {
      case "alot":
        return {
          grade: "파티원",
          abstract: "파티 분담금",
          addTo: "파티장",
        };
      case "reward":
        return {
          grade: "파티원/파티장",
          abstract: "리워드",
          addTo: "파티원/파티장",
        };
      case "netcomm":
        return {
          grade: "파티원/파티장",
          abstract: "링키드 수익",
          addTo: "링키드",
        };
      case "deposit":
        return {
          grade: "파티원",
          abstract: "파티 보증금",
          addTo: "링키드",
        };
      case "penalty":
        return {
          grade: "파티장",
          abstract: "해산 위약금",
          addTo: "파티원",
        };

      case "panelty":
        return {
          grade: "파티장",
          abstract: "위약금 결제",
          addTo: "파티원",
        };
      default:
        return {
          abstract: "",
          addTo: "",
          grade: "",
        };
    }
  } else if (type === "saving") {
    switch (true) {
      case /return_alot/i.test(details):
        if (reason === "break") {
          // 파티장의 파티 해산
          return {
            grade: "파티원",
            abstract: "해산으로 인한 잔여 파티 분담금 반환",
            addTo: "파티원",
          };
        } else {
          // 파티원의 파티 탈퇴
          return {
            grade: "파티원",
            abstract: "탈퇴로 인한 잔여 파티 분담금 반환",
            addTo: "파티원",
          };
        }
      case /return_deposit/i.test(details):
        return {
          grade: "파티원",
          abstract: "무책탈퇴로 인한 파티 보증금 반환",
          addTo: "파티원",
        };
      case /return_reward/i.test(details):
        if (reason === "break") {
          // 파티장의 파티 해산
          return {
            grade: "파티원",
            abstract: "잔여 리워드 반환",
            addTo: "파티원",
          };
        } else {
          // 파티원의 파티 탈퇴
          return {
            grade: "파티원",
            abstract: "잔여 리워드 반환",
            addTo: "파티원",
          };
        }

      case /return_netcomm/i.test(details):
        if (reason === "break") {
          // 파티장의 파티 해산
          return {
            grade: "파티원",
            abstract: "해산으로 인한 잔여 링키드 수익 반환",
            addTo: "파티원",
          };
        } else {
          // 파티원의 파티 탈퇴
          return {
            grade: "파티원",
            abstract: "탈퇴로 인한 잔여 링키드 수익 반환",
            addTo: "파티원",
          };
        }
      case /calc_reward/i.test(details):
        // 파티장의 파티 해산
        if (reason === "break") {
          return {
            grade: "파티원/파티장",
            abstract: "해산으로 인한 리워드 적립",
            addTo: "파티원",
          };
        } else {
          // 파티 종료
          return {
            grade: "파티원/파티장",
            abstract: "종료로 인한 리워드 적립",
            addTo: "파티원/파티장",
          };
        }

      case /calc_alot/i.test(details):
        return {
          grade: "파티장",
          abstract: `파티 분담금 적립 (${targetUid})`,
          addTo: "파티장",
        };
      case /calc_deposit/i.test(details):
        // 파티장의 파티 해산
        if (reason === "break") {
          return {
            grade: isOwner ? "파티장" : "파티원",
            abstract: isOwner
              ? "중도 탈퇴 보상금 적립"
              : `해산으로 인한 탈퇴 보증금 반환`,
            addTo: isOwner ? "파티장" : "파티원",
          };
        } else {
          // 파티 종료
          return {
            grade: "파티원",
            abstract: `종료로 인한 보증금 적립 (${targetUid ?? "본인"})`,
            addTo: "파티원",
          };
        }

      case /calc_penalty/i.test(details):
        return {
          grade: "파티원",
          abstract: "해산 위약금 보상",
          addTo: "파티원",
        };
      default:
        return {
          abstract: "",
          addTo: "",
          grade: "",
        };
    }
  } else if (type === "breakage") {
    switch (true) {
      case /breakage_allot/i.test(details):
        // 파티장의 파티 해산
        return {
          grade: "파티원/파티장",
          abstract: "파티 분담금 낙전 수익",
          addTo: "링키드",
        };

      case /breakage_reward/i.test(details):
        return {
          grade: "파티원/파티장",
          abstract: "파티 리워드 낙전 수익",
          addTo: "링키드",
        };

      case /breakage_deposit/i.test(details):
        // 파티장의 파티 해산
        return {
          grade: "파티원",
          abstract: `파티 보증금 낙전 수익`,
          addTo: "링키드",
        };

      case /breakage_penalty/i.test(details):
        return {
          grade: "파티원/파티장",
          abstract: "파티 위약금 낙전 수익",
          addTo: "링키드",
        };

      case /breakage_netcomm/i.test(details):
        // 파티장의 파티 해산
        return {
          grade: "파티원",
          abstract: `파티 수수료 낙전 수익`,
          addTo: "링키드",
        };

      case /breakage_alot/i.test(details):
        return {
          grade: "파티원",
          abstract: `파티 분담금 낙전 수익`,
          addTo: "링키드",
        };

      default:
        return {
          abstract: "",
          addTo: "",
          grade: "",
        };
    }
  } else if (type === "charge") {
    switch (details) {
      case "breakage_insolvency":
        return {
          grade: "파티장",
          abstract: "해산 위약금 링키드 대납",
          addTo: "파티원",
        };

      case "insolvency":
        return {
          grade: "파티장",
          abstract: "위약금 링키드 머니 충전 (먹튀)",
          addTo: "파티장",
        };

      default:
        return {
          abstract: "",
          addTo: "",
          grade: "",
        };
    }
  }
};

// 권한 데이터
export const authFuncData = [
  {
    id: 1,
    title: "회원 정보 열람",
    desc: "회원 기본 정보, 정산 정보, 파티 정보 등 조회",
    state: "userInfo",
  },
  {
    id: 2,
    title: "파티 정보 열람",
    desc: "공유 로그인 정보, 채팅 내역 등 조회",
    state: "partyInfo",
  },
  {
    id: 3,
    title: "파티 취소",
    desc: "파티 해산/탈퇴/매칭 취소 처리 가능",
    state: "partyCancel",
  },
  {
    id: 4,
    title: "블랙리스트 설정",
    desc: "블랙리스트 추가, 변경 가능",
    state: "black",
  },
  {
    id: 5,
    title: "블랙리스트 삭제",
    desc: "블랙리스트 삭제 가능",
    state: "blackDelete",
  },
  {
    id: 6,
    title: "코멘트 설정",
    desc: "코멘트 추가, 변경 가능",
    state: "comment",
  },

  {
    id: 7,
    title: "알림톡 보내기",
    desc: "알림톡 보내기 가능",
    state: "kakao",
  },
  {
    id: 8,
    title: "엑셀 다운로드",
    desc: "데이터 엑셀 다운로드 가능",
    state: "excelDownload",
  },
  {
    id: 9,
    title: "쿠폰 및 포인트 설정",
    desc: "쿠폰 및 포인트 지급, 포인트 스케줄 취소 가능",
    state: "couponAndPoint",
  },
  {
    id: 10,
    title: "유저 로그",
    desc: "유저 로그 조회 가능",
    state: "userLog",
  },
  {
    id: 11,
    title: "관리자 로그",
    desc: "관리자 로그 조회 가능",
    state: "adminLog",
  },
  {
    id: 12,
    title: "일몰 시스템 권한",
    desc: "일몰 시스템 설정 가능",
    state: "sunset",
  },
  {
    id: 13,
    title: "관리자 설정 권한",
    desc: "관리자 추가 및 삭제 가능",
    state: "adminSet",
  },
  {
    id: 14,
    title: "즉시 결제",
    desc: "회원의 등록된 결제 정보로 즉시 결제 요청 가능",
    state: "bill",
  },
  {
    id: 15,
    title: "링키드 머니 우선 결제",
    desc: "링키드 머니 우선 결제 설정 및 해제 가능",
    state: "linkidMoney",
  },
  {
    id: 16,
    title: "코멘트 삭제",
    desc: "코멘트 삭제 가능",
    state: "commentDelete",
  },
  {
    id: 17,
    title: "채팅 열람",
    desc: "채팅 검색, 채팅 신고/처리완료 가능",
    state: "chat",
  },
  {
    id: 18,
    title: "대시보드",
    desc: "대시보드 조회 가능",
    state: "dash",
  },
  {
    id: 19,
    title: "유플러스",
    desc: "유플러스 결합 접근 가능",
    state: "uplus",
  },
];

export const mgLogString = (details: string) => {
  switch (details) {
    case "alot":
      return "파티 분담금";
    case "reward":
      return "리워드";
    case "netcomm":
      return "링키드 수익";
    case "deposit":
      return "파티 보증금";
    case "penalty":
      return "해산 위약금";
    case "return_alot":
      return "잔여 파티 분담금 반환";
    case "return_deposit":
      return "파티 보증금 반환";
    case "return_reward":
      return "잔여 리워드 반환";
    case "return_netcomm":
      return "잔여 링키드 수익 반환";
    case "calc_reward":
      return "리워드 적립";
    case "calc_alot":
      return "파티 분담금 적립";
    case "calc_deposit":
      return "탈퇴 보증금 보상";
    case "calc_penalty":
      return "해산 위약금 보상";
    case "breakage_alot":
      return "파티 분담금 낙전 수익";
    case "breakage_reward":
      return "파티 리워드 낙전 수익";
    case "breakage_deposit":
      return "파티 보증금 낙전 수익";
    case "breakage_penalty":
      return "파티 위약금 낙전 수익";
    case "insolvency":
      return "해산 위약금 링키드 대납";
    default:
      return "";
  }
};

// 클립보드에 복사하기
export const copyTextToClipboard = async (
  text: string,
  toastMessage?: string,
) => {
  console.log(text);
  let success = false;

  if (text) {
    if (navigator.clipboard) {
      // (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
      navigator.clipboard
        .writeText(text)
        .then(() => {
          success = true;
          toast.success(`${toastMessage}`);
        })
        .catch(() => {
          alert("복사를 다시 시도해주세요.");
        });
    } else {
      // 흐름 2.
      if (!document.queryCommandSupported("copy")) {
        return alert("복사하기가 지원되지 않는 브라우저입니다.");
      }

      // 흐름 3.
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.top = "0px";
      textarea.style.left = "0px";
      textarea.style.position = "fixed";

      // 흐름 4.
      document.body.appendChild(textarea);
      // focus() -> 사파리 브라우저 서포팅
      textarea.focus();
      // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
      textarea.select();
      // 흐름 5.
      document.execCommand("copy");
      // 흐름 6.
      document.body.removeChild(textarea);

      success = true;
      toast.success(`${toastMessage}`);

      // alert("클립보드에 복사되었습니다.");
    }

    return success;
  }
};

// 알림톡 템플릿 가져오기
export const getAlimTalkTemplate = (id: number) => {
  const data = kkotalkEventSetData.find((val) => {
    return val.TLK_ID === id;
  });

  return data;
};

// json 형태의 파일을 엑셀 파일로 내보내기
export const exportJsonToExcel = (
  data: any,
  title: string,
  customTitle?: string,
  customData?: boolean,
) => {
  const book = utils.book_new();
  const worksheetByAoa = customData
    ? utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D"],
        skipHeader: true,
      })
    : utils.json_to_sheet(data);
  // 엑셀 파일에 sheet set(엑셀파일, 시트데이터, 시트명)
  utils.book_append_sheet(book, worksheetByAoa, "admin");

  // 엑셀 다운로드
  writeFile(
    book,
    customTitle ??
      `admin_${title}_${dayjs().format("YYYY-MM-DD HH:mm:ss")}.xlsx`,
  );
};

/** json 형태의 파일을 엑셀 파일로 내보내기 with style */
export const exportJsonToExcelStyle = (
  titleText: string,
  customTitleDesc?: any[][],
  titleDescText?: string,
  columnList?: string[],
  fileName?: string,
  sheetName?: string,
  data?: any[][],
  titleDescRowsHeight?: number,
  customMerge?: any[],
  customRows?: any[],
) => {
  const wb = XLSX.utils.book_new();

  const columnCnt = columnList?.length ?? 1;

  const infoStyle = {
    fill: { bgColor: { rgb: "FCE4D6" }, fgColor: { rgb: "FCE4D6" } },
    alignment: { vertical: "top", wrapText: true },
    font: { sz: "10" },
  };

  const titleStyle = {
    ...infoStyle,
    font: { bold: true, sz: "12" },
  };

  const columnStyle = {
    ...titleStyle,
    fill: { bgColor: { rgb: "F2F2F2" }, fgColor: { rgb: "F2F2F2" } },
  };

  const title = [
    {
      v: titleText,
      t: "s",
      s: titleStyle,
    },
  ];

  let titleDesc = [
    {
      v: titleDescText ?? "",
      t: "s",
      s: infoStyle,
    },
  ];

  const column: { v: string; t: string; s: object }[] = [];
  const colStyle: { wpx: number }[] = [];

  columnList?.forEach((c) => {
    column.push({
      v: c,
      t: "s",
      s: columnStyle,
    });

    colStyle.push({
      wpx: 231,
    });
  });

  let worksheet = [title, titleDesc, column];

  if (customTitleDesc) {
    customTitleDesc?.forEach((c, i) => {
      worksheet.splice(i + 1, i === 0 ? 1 : 0, c);
    });
  }

  if (data && data?.length > 0) {
    data?.forEach((eachData) => {
      worksheet.push(eachData);
    });
  }

  console.log(worksheet);

  // STEP 3: row로 worksheet를 생성한다.
  const ws = XLSX.utils.aoa_to_sheet(worksheet);

  ws["!merges"] = customMerge ?? [
    { s: { r: 0, c: 0 }, e: { r: 0, c: columnCnt - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: columnCnt - 1 } },
  ];
  ws["!rows"] = customRows ?? [
    { hpx: 17.25 },
    { hpx: titleDescRowsHeight ?? 51.75 },
  ];

  ws["!cols"] = colStyle;

  // worksheet를 workbook에 추가한다.
  XLSX.utils.book_append_sheet(wb, ws, sheetName ?? "Data");

  // 엑셀 다운로드
  XLSX.writeFile(
    wb,
    `${fileName}_${dayjs().format("YY년 MM월 DD일 HH시 mm분")}.xlsx`,
  );
};

/** 엑셀 파일 읽고 json 형태로 가져오기 */
export const readExcelFile = (
  file: File,
  callback: IWorkBookCallBack,
  errorCallback?: () => void,
) => {
  const reader = new FileReader();

  console.log(reader);

  if (reader) {
    reader.readAsArrayBuffer(file);
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const data = e.target?.result;

      const workbook = read(data, { type: "array" });

      if (workbook) {
        callback(workbook);
      }
    };
  } else {
    if (errorCallback) {
      errorCallback();
    }
  }
};

/** excel workbook to json array */
export const workbookToJsonArray = (
  workbook: WorkBook,
  headerRowIndex?: number,
) => {
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const json = utils.sheet_to_json(worksheet, {
    defval: null,
    ...(headerRowIndex && { raw: false, range: headerRowIndex - 1 }),
  }) as any[][];

  const arr: any[] = [];

  json.forEach((item) => {
    const stringed = JSON.stringify(item); // __rowNum__ 제거 위해
    const parse = JSON.parse(stringed);

    arr.push(parse);
  });

  return arr;
};

// 알림톡 성인 인증 요청 알림톡 추가 메세지
export const alimTalkAdltDefaultMsg = (subsId: number) => {
  switch (subsId) {
    case 1001:
    case 1002:
    case 1100:
      return `넷플릭스 성인 인증 방법을 알려드릴게요.\n1️⃣ 넷플릭스 로그인\n2️⃣ 성인 인증 진행(https://www.netflix.com/verifyage)`;

    case 2000:
      return `왓챠 성인 인증 방법을 알려드릴게요.\n1️⃣ 왓챠 로그인\n2️⃣ 설정 페이지 접속 (https://watcha.com/settings)\n3️⃣ '성인 인증' 진행`;

    case 3000:
      return `웨이브 성인 인증 방법을 알려드릴게요.\n1️⃣ 웨이브 로그인\n2️⃣ 성인 인증 진행 (https://member.wavve.com/mobile/auth/verifyage)\n3️⃣ 성인 인증 후 PIN을 링키드에 등록`;

    case 4000:
    case 4001:
      return `티빙 성인 인증 방법을 알려드릴게요.\n1️⃣ 티빙 로그인\n2️⃣ 성인 콘텐츠 선택 후, 본인 정보로 성인 인증 진행`;

    case 5000:
    case 5001:
      return `디즈니플러스 성인 인증 방법을 알려드릴게요.\n1️⃣ PC로 디즈니 플러스 웹사이트(https://www.disneyplus.com/ko-kr/) 접속\n2️⃣ 본인 프로필(링키드 닉네임) 들어가기\n3️⃣ 성인 인증 페이지(https://www.disneyplus.com/ko-kr/verifyage) 열기\n4️⃣ 각 파티원 본인 정보로 성인 인증 진행하기`;

    case 7001:
      return `프라임 비디오 성인 인증 방법을 알려드릴게요.\n1️⃣ 프라임 비디오 로그인\n2️⃣ 성인 콘텐츠 재생 후 성인 인증 진행`;

    case 15001:
    case 15002:
      return `애플 성인 인증 방법을 알려드릴게요.\n1️⃣ 애플 로그인\n2️⃣ 성인 콘텐츠 선택 후, 본인 정보로 성인 인증 진행`;

    case 16000:
      return `라프텔 성인 인증 방법을 알려드릴게요.\n1️⃣ 라프텔 로그인\n2️⃣ 성인 콘텐츠 재생 후 성인 인증 진행`;

    default:
      return "";
  }
};

// 알림톡 자동 완성 메시지
export const alimTalkDefaultMsg = (talkId: number) => {
  switch (talkId) {
    case 2008:
      return `YYYY년 MM월 DD일 00시까지 결제가 이뤄지지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n각별한 주의와 빠른 조치 바랍니다.`;

    case 2009:
      return `YYYY년 MM월 DD일 00시까지 정확한 정보로 수정되지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n🚨 꼭 아래 순서대로 진행해 주세요!\n1️⃣ '#{svc_nm}'에서 비밀번호 변경하기\n2️⃣ 변경된 비밀번호 링키드 '나의 파티'에 반영하기\n\n각별한 주의와 빠른 조치 바랍니다.`;

    case 2011:
      return "YYYY년 MM월 DD일 00시까지 파티원을 초대하지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n각별한 주의와 빠른 조치 바랍니다.";

    case 2017:
      return `#{reason} 이후 비밀번호를 변경하지 않아 이전 파티원이 파티 계정에 접근할 수 있습니다.\n\n원활한 파티 진행을 위해 비밀번호 변경을 권장 드립니다.\n\n🚩꼭 아래 순서로 진행해주세요!\n1️⃣'#{svc_nm}'에서 비밀번호 변경, 모든 기기에서 로그아웃 체크\n2️⃣변경된 비밀번호 '링키드'에 반영하기`;

    case 2022:
      return "💌 초대할 파티원\n- 링키드 닉네임:\n- 계정:\n\nYYYY년 MM월 DD일 00시까지 해당 파티원을 정상 초대하지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n각별한 주의와 빠른 조치 바랍니다.";

    case 2027:
      return "YYYY년 MM월 DD일 00시까지 파티원을 초대하지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n각별한 주의와 빠른 조치 바랍니다.";

    case 2028:
      return "YYYY년 MM월 DD일 00시까지 파티원을 초대하지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n각별한 주의와 빠른 조치 바랍니다.";

    case 2030:
      return "YYYY년 MM월 DD일 00시까지 iCloud+ 공유를 진행하지 않을 경우 파티 강제 해산 및 위약금이 청구됩니다.\n\n각별한 주의와 빠른 조치 바랍니다.";

    case 2031:
      return "YYYY년 MM월 DD일 00시까지 iCloud+ 용량을 조정하지 않을 경우 해당 파티에서 탈퇴 처리, 보증금 환급이 불가합니다.\n\n각별한 주의와 빠른 조치 바랍니다.";

    case 2035:
      return "[파티 공유 계정 문제]\n🚫 OOOO 파티의 이용권 미결제\n🕑 YYYY년 MM월 DD일 hh시까지 문제 상태 방치\n\n이에 따라 고객님이 파티 생성 시 확인 및 동의한 파티 규칙에 의거하여 파티를 강제 해산하고, 파티원들에게 보상하기 위한 위약금 ####원을 청구하였습니다.\n\n하지만 고객님이 등록한 결제 수단에 오류가 발생하여, 위약금 결제에 실패한 상태입니다. 이에 링키드는 소속 파티원들의 권리 보호를 위해 고객님께서 미지불한 위약금을 파티원님들께 대위 변제한 상태입니다.\n\n이에 따라 YYYY년 MM월 DD일 hh시까지 아래 링키드 고객센터로 연락하여, 해당 위약금 지불을 요청 드립니다.";

    case 2036:
      return "[초대할 파티원 정보]\n- 닉네임 :\n- 이메일 :\n- 도움말 : https://linkid.pw/faq/121\n\nYYYY년 MM월 DD일 00시까지 파티원을 초대하지 않을 경우, 링키드 파티 규칙에 따라 파티 강제 해산 및 위약금을 청구할 예정이에요.";

    case 2037:
      return "[다시 초대할 파티원 정보]\n- 닉네임 :\n- 이메일 :\n- 도움말 : https://linkid.pw/faq/121\n\nYYYY년 MM월 DD일 00시까지 해당 파티원을 꼭 다시 초대해 주세요.";

    default:
      return "";
  }
};

export const fnBrowserDetect = () => {
  let userAgent = navigator.userAgent;

  let browserName;

  if (userAgent.match(/NAVER/i)) {
    browserName = "naver";
  } else if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }

  return browserName;
};

// 숫자 입력시 콤마 찍기
export const changeNumComma = (e: ChangeEvent<HTMLInputElement>) => {
  const value: string = e.target.value;
  const removedCommaValue: number = isNaN(Number(value.replaceAll(",", "")))
    ? 0
    : Number(value.replaceAll(",", ""));

  return removedCommaValue;
};

// 알림톡 API 데이터 가져오기
export const getAlimtalkStatus = (code: number) => {
  const data = alimtalkStatus.find((val) => {
    return val.code === code;
  });

  return data;
};

// SMS status 데이터 가져오기
export const getSmsStatus = (code: number) => {
  const data = smsStatus.find((val) => {
    return val.code === code;
  });

  return data;
};

// kakao status 데이터 가져오기
export const getKakaoStatus = (code: string) => {
  console.log(code);

  const data = kakaoStatus.find((val) => {
    return val.code === code;
  });

  return data;
};

export const mgLogType = () => [
  { value: "calc_alot", label: "파티 분담금 적립", category: "" },
  { value: "reward", label: "리워드", category: "거래" },
  { value: "netcomm", label: "링키드 수익", category: "거래" },
  { value: "card", label: "카드", category: "예치금" },
  { value: "alot", label: "파티 분담금", category: "" },
  { value: "deposit", label: "파티 보증금", category: "거래" },
  { value: "panelty", label: "해산 위약금", category: "거래" },
  { value: "return_alot", label: "잔여 파티 분담금 반환", category: "환불" },
  { value: "return_reward", label: "잔여 리워드 반환", category: "환불" },
  { value: "return_netcomm", label: "잔여 링키드 수익 반환", category: "환불" },
  { value: "return_deposit", label: "파티 보증금 반환", category: "환불" },
  {
    value: "breakage_penalty",
    label: "파티 위약금 낙전 수익",
    category: "낙전",
  },
  { value: "coupon", label: "쿠폰", category: "프로모션" },
  {
    value: "breakage_deposit",
    label: "파티 보증금 낙전 수익",
    category: "낙전",
  },
  { value: "calc_deposit", label: "탈퇴 보증금 보상", category: "" },
  { value: "calc_reward", label: "리워드 적립", category: "" },
  { value: "point", label: "링키드 포인트", category: "프로모션" },
  { value: "insolvency", label: "해산 위약금 링키드 대납", category: "" },
  { value: "withdraw", label: "링키드 머니 인출", category: "예치금" },
];

// byte 체크
export const fnChkByte = (value: string, maxByte: number) => {
  let str = value ?? "";
  let str_len = str.length;

  let rbyte = 0;
  let rlen = 0;
  let one_char = "";
  let str2 = "";

  for (let i = 0; i < str_len; i++) {
    one_char = str.charAt(i);
    if (escape(one_char).length > 4) {
      rbyte += 2; // 한글2Byte
    } else {
      rbyte++; // 영문 등 나머지 1Byte
    }
    if (rbyte <= maxByte) {
      rlen = i + 1; // return할 문자열 갯수
    }
  }

  if (rbyte > maxByte) {
    // alert("한글 "+(maxByte/2)+"자 / 영문 "+maxByte+"자를 초과 입력할 수 없습니다.");
    //   alert("메세지는 최대 " + maxByte + "byte를 초과할 수 없습니다.");
    str2 = str.substr(0, rlen); // 문자열 자르기
    value = str2;
    fnChkByte(value, maxByte);
  }
};

// altemp로 alimtalk 템플릿 찾기
export const getAlimTalkTemplateByAltemp = (
  altemp: number, // 일몰 유형 템플릿 아이디
  notiCase: number, // 0: 매칭 대기, 1: 예정, 2: 파티종료일<한달, 3: 파티 종료일>한달_파티장, 4: 파티 종료일>한달_파티원, 5: 초대 수락_파티원
  sunsetType: number, // 0: opt-out, 1: opt-in
) => {
  const sunsetUserEventSet = ssetUserEvent?.find(
    (d) => d.SSETTEMPLATE_ID === altemp,
  );

  const eventId =
    notiCase === 0
      ? sunsetUserEventSet?.REQ_USEREVT
      : notiCase === 1
        ? sunsetUserEventSet?.PRE_USEREVT
        : notiCase === 2
          ? sunsetUserEventSet?.EDATECHG_USEREVT
          : notiCase === 5
            ? sunsetUserEventSet?.OPTINIVT_USEREVT
            : notiCase > 2
              ? sunsetType === 1
                ? sunsetUserEventSet?.OPTIN_USEREVT
                : sunsetUserEventSet?.OPTOUT_USEREVT
              : 0;

  const talkId = autoPushEvent?.find(
    (d) =>
      d.ALM_USEREVT === eventId &&
      (notiCase === 3
        ? d.ALM_USERTYP === "ldr"
        : notiCase === 4
          ? d.ALM_USERTYP === "mbr"
          : true),
  )?.TLK_ID;

  const alimTalk = getAlimTalkTemplate(talkId ?? 0);

  return alimTalk?.TLK_DESC ?? "";
};

export const getPopupReasonString = (
  type: number,
  list?: { id: number; name: string }[],
) => {
  if (list) {
    const typeData = list?.find((a) => a.id === type);

    return typeData?.name ?? "";
  } else {
    switch (type) {
      case 0:
        return "LMS 발송 실패";

      case 1:
        return "알림톡 발송 실패";

      case 2:
        return "커스텀 팝업";

      default:
        return "-";
    }
  }
};

/** susbscription 드롭 다운 선택 리스트 */
export const getSubscriptionOptionList = (
  allSubs?: boolean,
  openId?: boolean,
) => {
  const subsOptionList = [];
  const subsNameList = allSubs
    ? GetAllSubsnameListV3() // active subscription
    : openId
      ? GetAllNoHideSubsnameListv3()?.filter((a) => {
          const subsId = +a?.split("_")[0];

          const subsData = GetSubscriptionSetData_V3(subsId ?? 0);
          const shareInfoData = getShareDefData(subsData?.SHARDEF_ID ?? 0, 0);

          return shareInfoData?.SHARDEF_TYP === "open_id" && subsId < 19000;
        })
      : GetAllNoHideSubsnameListv3(); // hide 항목 제외

  for (let i = 0; i < subsNameList.length; i++) {
    const e = subsNameList[i];

    subsOptionList.push({ value: e?.split("_")[0], label: e });
  }

  return subsOptionList;
};

/** 자주 묻는 질문, 공지사항, 약관 등 UI가 비슷한 페이지에서 사용할 스트링 */
export const commonString = (pathname: string) => {
  const isFaq = Boolean(pathname.includes("faq"));
  const isNotice = Boolean(pathname.includes("notice"));

  return {
    title: isFaq ? "자주 묻는 질문" : isNotice ? "공지사항" : "약관",
    route: isFaq ? "faq" : isNotice ? "notice" : "terms",
    packetUrl: isFaq ? "FAQ" : isNotice ? "notice" : "terms",
    type: isFaq ? 0 : isNotice ? 1 : 2,
  };
};

/** json 파일 => 엑셀 다운로드 */
export const jsonToExcel = (jsonFile: any[], fileName: string) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = utils.json_to_sheet(jsonFile);

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  saveAs(data, `${fileName}`);
};

export const alitalkTemplateOptionList = (
  shareInfoType: string,
  svcId: number,
  selectedSubsId: string,
  grade?: number,
) => {
  return [
    {
      value: "2008",
      label: "이용권 결제 요청",
      isDisabled: (grade! >= 0 ? grade === 0 : true) ? false : true,
    },
    {
      value: "2009",
      label: "로그인 정보 수정 요청",
      isDisabled:
        shareInfoType === "open_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2010",
      label: "네이버 플러스 패밀리 (파티장)",
      isDisabled:
        selectedSubsId === "14000" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2011",
      label: "파티원 초대 요청",
      isDisabled:
        shareInfoType !== "open_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2012",
      label: "임시 계정 안내",
      isDisabled:
        shareInfoType === "open_id" || selectedSubsId === "1100" ? false : true,
    },
    {
      value: "2013",
      label: "프로필 규칙 준수 요청",
      isDisabled: shareInfoType === "open_id" ? false : true,
    },
    {
      value: "2014",
      label: "동시 접속 초과 경고",
      isDisabled: shareInfoType === "open_id" ? false : true,
    },
    {
      value: "2015",
      label: "성인 인증 요청(파티장)",
      isDisabled:
        (grade! >= 0 ? grade === 0 : true) &&
        (selectedSubsId === "1001" ||
          selectedSubsId === "1100" ||
          selectedSubsId === "2000" ||
          selectedSubsId === "3000" ||
          selectedSubsId === "7001" ||
          selectedSubsId === "16000")
          ? false
          : true,
    },
    {
      value: "2018",
      label: "성인 인증 방법 안내(파티원)",
      isDisabled:
        (grade! >= 0 ? grade === 1 : true) &&
        (selectedSubsId === "1100" ||
          selectedSubsId === "4000" ||
          selectedSubsId === "4001" ||
          selectedSubsId === "5000" ||
          selectedSubsId === "5001" ||
          selectedSubsId === "15001" ||
          selectedSubsId === "15002")
          ? false
          : true,
    },
    { value: "2020", label: "파티 해산 안내" },
    {
      value: "2017",
      label: "비밀번호 변경 요청",
      isDisabled:
        shareInfoType === "open_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2034",
      label: "디즈니 2차 인증 비밀번호 변경 요청",
      isDisabled:
        (grade! >= 0 ? grade === 0 : true) && svcId === 500 ? false : true,
    },
    { value: "2016", label: "파티 정상 이용 가능 안내" },
    {
      value: "2022",
      label: "허위 등록 완료 경고",
      isDisabled:
        shareInfoType === "register_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2023",
      label: "네이버 플러스 패밀리 (파티원)",
      isDisabled:
        selectedSubsId === "14000" && (grade! >= 0 ? grade === 1 : true)
          ? false
          : true,
    },
    {
      value: "2024",
      label: "서비스 초대 불가 안내 (파티장)",
      isDisabled:
        shareInfoType !== "open_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2025",
      label: "서비스 초대 불가 안내 (파티원)",
      isDisabled:
        shareInfoType !== "open_id" && (grade! >= 0 ? grade === 1 : true)
          ? false
          : true,
    },
    {
      value: "2026",
      label: "프라임 비디오 연락처 삭제 요청",
      isDisabled: selectedSubsId === "7001" ? false : true,
    },
    {
      value: "2027",
      label: "파티원 초대 요청 (레지스터)",
      isDisabled:
        shareInfoType === "register_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2028",
      label: "파티원 초대 요청 (인바이트)",
      isDisabled:
        shareInfoType === "invite_mail" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2029",
      label: "애플 초대 메일 발송 오류",
      isDisabled: svcId === 1500 ? false : true,
    },
    {
      value: "2030",
      label: "아이클라우드 공유 설정 (파티장)",
      isDisabled:
        svcId === 1500 && (grade! >= 0 ? grade === 0 : true) ? false : true,
    },
    {
      value: "2031",
      label: "아이클라우드 용량 조정 (파티원)",
      isDisabled:
        svcId === 1500 && (grade! >= 0 ? grade === 1 : true) ? false : true,
    },
    {
      value: "2032",
      label: "애플 공유 오류 대응 요청 (파티장)",
      isDisabled:
        svcId === 1500 && (grade! >= 0 ? grade === 0 : true) ? false : true,
    },
    {
      value: "2033",
      label: "파티원 변경 후 비밀번호 변경 요청",
      isDisabled:
        shareInfoType === "open_id" && (grade! >= 0 ? grade === 0 : true)
          ? false
          : true,
    },
    {
      value: "2035",
      label: "위약금 대위 변제",
      isDisabled: (grade! >= 0 ? grade === 0 : true) ? false : true,
    },
    {
      value: "2036",
      label: "파티원 초대 요청 (추가 공유)",
      isDisabled: svcId === 110 ? false : true,
    },
    {
      value: "2037",
      label: "파티원 재초대 요청 (추가 공유)",
      isDisabled: svcId === 110 ? false : true,
    },
  ];
};

/** 알림톡 템플릿 정렬: 활성화 - 비활성화  */
export const sortedTemplateList = (
  templateOptionList: { value: string; label: string; isDisabled?: boolean }[],
) => {
  let list: any[] = [];
  let activeList: any[] = [];
  let inActiveList: any[] = [];

  const sortedList = templateOptionList.sort((a, b) => {
    let x = a.label.toLowerCase();
    let y = b.label.toLowerCase();

    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  });

  sortedList.forEach((d) => {
    if (d.isDisabled === true) {
      inActiveList.push(d);
    } else {
      activeList.push(d);
    }
  });

  list = [...activeList, ...inActiveList];

  return list;
};

export const MATCHMAKING_SUBS_LIST = [
  1001, 1100, 1190, 2000, 3000, 4000, 4001, 4002, 4100, 5000, 5001, 5002, 5100,
  7001, 9000, 9001, 9002, 20001, 20002, 24000, 24001, 24002, 15000, 15001,
  10000, 27000, 28000, 28100, 29000, 30000, 31000, 32000, 33000, 34000, 36000,
  36100, 38000, 40000, 50000, 30100, 30200, 11001,
];

export const getMatchMakingSubsOptionList = () => {
  const list: OptionType[] = [];

  MATCHMAKING_SUBS_LIST?.forEach((d) => {
    const subsData = GetSubscriptionSetData(d);

    list.push({
      value: `${d}`,
      label: `${d}_${getSubsNameBySubsId3(d)}`,
    });
  });

  return list;
};

export const getN_MatchMakingSubsList = () => {
  let list: number[] = [];
  subscription_set_V3.map((d) => {
    if (d?.SUBS_ID % 100 >= 90) {
      list.push(d?.SUBS_ID);
    }
  });
  return list;
};

export const getN_MatchMakingSubsOptionList = () => {
  const list: OptionType[] = [];
  const subsList = getN_MatchMakingSubsList();

  subsList?.forEach((d) => {
    // const subsData = GetSubscriptionSetData_V3(d);

    list.push({
      value: `${d}`,
      label: `${d}_${getSubsNameBySubsId3(d)}`,
    });
  });

  return list;
};

/** 파티 상세: 등록 상태 스트링 */
export const getPartyRegState = (
  grade: number,
  needreg: number,
  macro?: number,
) => {
  if (grade === 0) {
    return "-";
  }

  if (macro && macro > 0) {
    switch (true) {
      case macro === 1 || macro === 8 || macro === 9:
        return "등록 완료";

      case macro === 9 ||
        macro === 10 ||
        macro === 11 ||
        macro === 14 ||
        macro === 15:
        return "-";

      default:
        return "최초 등록 전";
    }
  }

  switch (needreg) {
    case 0:
      return "등록 완료";

    case 1:
      return "최초 등록 전";

    case 2:
      return "수정 등록 전";

    default:
      return "-";
  }
};

export const getPartyStatusText = (partyStatus: number, enddate: string) => {
  const remainDay = getDiffDay(
    dayjs().format("YYYY-MM-DD"),
    dayjs(enddate).add(-1, "day").format("YYYY-MM-DD"),
  ); // 종료일(보여주기 기준)까지 남은 일수

  switch (partyStatus) {
    case CPState.CPS_Before:
      return {
        text: "예정",
        color: "#ffb100",
      };

    case CPState.CPS_Using:
      return {
        text: remainDay < 10 ? `${remainDay}일 후 종료` : "파티중",
        color: "#00c7c7",
      };

    case CPState.CPS_ExitReady:
    case CPState.CPS_Sunset_to_Come:
    case CPState.CPS_Expelled:
      return {
        text: "파티중",
        color: "#00c7c7",
      };

    case CPState.CPS_Broken: // 6
      return {
        text: "해산",
        color: "#f42d16",
      };

    case CPState.CPS_Broken_Admin:
      return {
        text: "유책 해산",
        color: "#f42d16",
      };

    case CPState.CPS_no_reason_broken:
      return {
        text: "완전 무책 해산",
        color: "#f42d16",
      };

    case CPState.CPS_1_broken:
      return {
        text: "일할 무책 해산",
        color: "#f42d16",
      };

    case CPState.CPS_eat_n_run:
      return {
        text: "먹튀 해산",
        color: "#f42d16",
      };

    case CPState.CPS_Before_Broken:
      return {
        text: "예정 해산",
        color: "#f42d16",
      };

    case CPState.CPS_pre_no_reason_broken:
      return {
        text: "예정 해산 (어드민)",
        color: "#f42d16",
      };

    case CPState.CPS_Sunset_Ended:
      return {
        text: "일몰 종료",
        color: "#858c97",
      };

    case CPState.CPS_Ended:
      return {
        text: "종료",
        color: "#858c97",
      };

    default:
      return { text: "", color: "" };
  }
};

export const getMyPartyStatusText = (mystate: number) => {
  switch (mystate) {
    case CPState.CPS_Before:
      return {
        text: "예정",
        color: "#ffb100",
      };

    case CPState.CPS_Using:
    case CPState.CPS_Sunset_to_Come:
      return {
        text: "파티중",
        color: "#00c7c7",
      };

    case CPState.CPS_Ended:
      return {
        text: "종료",
        color: "#858c97",
      };

    case CPState.CPS_Exited: // 4: 탈퇴
      return {
        text: "탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_Expelled: // 9: 넷플릭스 추방
      return {
        text: "내보내기 탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_no_reason_Exit: // 20: 무책 탈퇴
      return {
        text: "완전 무책 탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_1_Exit: // 21: 일할 무책 탈퇴
      return {
        text: "일할 무책 탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_reward_1_Exit: // 22: 보상 일할 무책 탈퇴
      return {
        text: "보상 탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_Exit_Admin: // 23: 어드민 유책 탈퇴
      return {
        text: "유책 탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_Broken: // 6: 해산
      return {
        text: "해산",
        color: "#f42d16",
      };

    case CPState.CPS_no_reason_broken: // 30: 무책 해산
      return {
        text: "완전 무책 해산",
        color: "#f42d16",
      };

    case CPState.CPS_1_broken: // 31: 일할 무책 해산
      return {
        text: "일할 무책 해산",
        color: "#f42d16",
      };

    case CPState.CPS_eat_n_run: // 32: 먹튀
      return {
        text: "먹튀 해산",
        color: "#f42d16",
      };

    case CPState.CPS_Broken_Admin: // 33: 어드민 유책 해산
      return { text: "유책 해산", color: "#f42d16" };

    case CPState.CPS_Sunset_Ended:
      return {
        text: "일몰 종료",
        color: "#858c97",
      };

    case CPState.CPS_Before_join_fail: // 32: 먹튀
      return {
        text: "예정 가입 실패",
        color: "#f42d16",
      };

    case CPState.CPS_Before_Exited: // 32: 먹튀
      return {
        text: "예정 탈퇴",
        color: "#f42d16",
      };

    case CPState.CPS_pre_no_reason_Exit: // 예정 탈퇴 (어드민)
      return {
        text: "예정 탈퇴 (어드민)",
        color: "#f42d16",
      };

    case CPState.CPS_Before_Broken: // 32: 먹튀
      return {
        text: "예정 해산",
        color: "#f42d16",
      };

    case CPState.CPS_pre_no_reason_broken: // 예정 해산 (어드민)
      return {
        text: "예정 해산 (어드민)",
        color: "#f42d16",
      };

    default:
      return {
        text: "",
        color: "",
      };
  }
};

export const getAdminAlimtalkAllTemplate = () => {
  const list: OptionType[] = [];

  const alertData = alertevent_set?.filter(
    (a) => 900 <= a.USEREVT_ID && a.USEREVT_ID < 1000,
  );

  alertData?.forEach((a) => {
    const userEventData = getUserEventData(a.USEREVT_ID);
    list.push({
      value: `${a.KKO_TPLID}`,
      label: `${userEventData?.USEREVT_DETAIL}`,
    });
  });

  return list;
};

export const getAlimtalkAllTemplate = () => {
  const list: OptionType[] = [];

  alertevent_set?.forEach((a) => {
    const userEventData = getUserEventData(a.USEREVT_ID);
    list.push({
      value: `${a.KKO_TPLID}`,
      label: `${userEventData?.USEREVT_DETAIL}`,
    });
  });

  return list;
};
